class Point {

    static getPoint(request) {


        return new Promise((resolve, reject) => {
            if (!request) {
                reject('no request string')
                return
            }
            const req = encodeURI(request)

            fetch(`https://nominatim.openstreetmap.org/search.php?q=${req}&format=geocodejson`).then(resp => {
                if (resp && resp.status === 200) {
                    resp.json().then(json => {
                        if (json && json.features && json.features[0] && json.features[0].geometry) {
                            resolve({
                                geometry: json.features[0].geometry.coordinates.reverse()
                            })
                        } else {
                            reject()
                        }
                    })
                }
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default Point


// WEBPACK FOOTER //
// ./src/Utils/Point.js